// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"FuelGradeSelector_wrapper__SnIOq","fuel-grade-icon":"FuelGradeSelector_fuel-grade-icon__mUOml","selected-item":"FuelGradeSelector_selected-item__1dSDS"};